import { useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type MutationFnParams = {
  verificationId: string
  amount: string
  companyId: string
  isRecurring: boolean
  payerCoversFee: boolean
}

export function useCharityCreateAnonymous() {
  return useMutation<void, unknown, MutationFnParams>({
    mutationFn: async ({ verificationId, companyId, amount, payerCoversFee, isRecurring }) => {
      await fetcher("/Transaction/Charity/CreateAnonymous", {
        method: "POST",
        body: JSON.stringify({
          verificationId,
          amount: {
            value: Math.round(Number(amount) * 100 + Number.EPSILON),
            currencyCode: "USD",
          },
          companyId,
          payerCoversFee,
          isRecurring,
        }),
      })
    },
  })
}
